"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProjectGroupResponseDtoFieldEnumKey } from "@dc/gateway-jsonapi";
import { usePersistedState } from "@dc/hooks";
import { getProjectGroupingKey } from "@/app/[locale]/[orgId]/[teamId]/(main)/files/utils";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { useOrganization } from "@/hooks/useOrganization";
import { useTeamsContext } from "@/hooks/useTeamsContext";
export interface UseProjectsHomeHrefReturn {
  /** Logical path. Callers must wrap with `useOrgTeamPath().build()` for navigation. */
  href: string;
  isReady: boolean;
}
export function useProjectsHomeHref() {
  const $ = _c(7);
  const {
    currentOrganizationId
  } = useOrganization();
  const {
    currentTeamId
  } = useTeamsContext();
  const {
    "projects-show-smart-folders-pd-6-467": smartFoldersEnabled
  } = useFeatureFlags();
  let t0;
  if ($[0] !== currentOrganizationId || $[1] !== currentTeamId) {
    t0 = getProjectGroupingKey(currentOrganizationId, currentTeamId);
    $[0] = currentOrganizationId;
    $[1] = currentTeamId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [groupBy] = usePersistedState(t0);
  const isReady = !!currentOrganizationId && !!currentTeamId && smartFoldersEnabled !== undefined;
  if (isReady && smartFoldersEnabled && groupBy) {
    const t1 = `/grouped-projects?groupBy=${encodeURIComponent(groupBy)}`;
    let t2;
    if ($[3] !== t1) {
      t2 = {
        href: t1,
        isReady: true
      };
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== isReady) {
    t1 = {
      href: "/files",
      isReady
    };
    $[5] = isReady;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}